export default __webpack_public_path__ + "static/media/DP2 2B-1EC.8834cd07.jpg";